module.exports = __webpack_public_path__ + "assets/img/iframe-bg.50388a38.png";